import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { MachineSession, Member } from '@/models';
import { Auth, DataStore, Hub, Predicates } from 'aws-amplify';
import {ref, inject, onMounted} from 'vue'
import { useRoute, useRouter } from 'vue-router';
import { useCookies } from 'vue3-cookies';
import oauthProd from '../aws-oauth-config.prod'
import oauthStg from '../aws-oauth-config.stg'


export default /*#__PURE__*/_defineComponent({
  emits: ['stopLoading'],
  setup(__props, { emit }) {

const {cookies} = useCookies();


emit('stopLoading');

cookies.set('shopId', 'ddaa348c-f110-4612-95d1-1e7674e434a0');

Auth.configure({ oauth: process.env.ENV == 'prod' ? oauthProd : oauthStg })

const router = useRouter();
const route = useRoute();

const api: any = inject('api');

try {    
  const query: any = route.query;

  if (query['token']) {
    cookies.set('token', query['token']);
  }
  else {
    cookies.remove('token');
  }
}
catch(e) {
  console.log(e);
}

const redirect = async(token: string) => {
  try {
    const session = await api.getMachineSessionByToken(token);
    console.log(session);

    const authSession = await Auth.currentSession();
    const cogToken = authSession.getAccessToken().getJwtToken();

    const user = await Auth.currentAuthenticatedUser();
    const buf = (await DataStore.query(Member, (m) => m.cogUser('eq', user.username)));

    const res = await api.updateMachineSession(token, buf.length > 0 ? buf[0].id : null, cogToken);

    console.log(res);


    const url = process.env.MOBILE_BACK_URL + '/payment?token=' + token;

    location.href = url;
  }
  catch(e) {
    console.log(e);
  }
}


const initDataStore = async() => {
  console.log('DataStore start...');
  await DataStore.clear();
  try {

    await Hub.listen('datastore', async (data) => {
      console.log(data);
      if (data.payload.event === 'ready') {
        console.log('DataStore ready');

        const token = cookies.get('token');

        if (token) {
          redirect(token);
        }
        else {
          router.push('/');
        }
      }
    });
    await DataStore.start();

  }
  catch(e) {
    console.log(e);
  }
}

const init = async() => {
  const user = await Auth.currentAuthenticatedUser();
  
  console.log(user);
  console.log(route.query);
  
  if (user) {
    await initDataStore();
  }
  else {
    await Hub.listen('auth', async (data) => {
      switch (data.payload.event) {
        case "signIn": {
          const cognitoUser = await Auth.currentAuthenticatedUser();
          console.log(`signed in ... ${cognitoUser.username}`);
          await initDataStore();
          break;
        }
      }
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_amplify_authenticator = _resolveComponent("amplify-authenticator")!

  return (_openBlock(), _createBlock(_component_amplify_authenticator, null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (init()))
      }, "Amplify認証（ローカル用）")
    ]),
    _: 1
  }))
}
}

})